export default __webpack_public_path__ + "static/media/bland.1725457d.webp";